module.exports = __webpack_public_path__ + "img/Dr-Glenn-Dahl.5a629c3e.png";